


<ng-container *ngIf="loading">
  <app-loader text="Моля изчакайте..."></app-loader>
</ng-container>

<ng-container *ngIf="!loading">
  <div style="margin-top:60px;display:flex;justify-content:center;align-items:center;padding-top:60px">
    <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
      <div class="card basic-tab-sect">
        <div class="card-body">
          <section class="row signal-requestor-wrapper">

            <h4>Местоположение на аварията</h4>
            <label class="col-form-label">Изберете локация на аварията <span class="font-danger">*</span></label>
            <div class="map-container-wrapper mb-3">
              <app-map-location-selector [location]="incidentLocation"
                                         [zoom]="16"
                                         (locationUpdated)="onLocationUpdated($event)">
              </app-map-location-selector>
            </div>
            <hr class="mt-4 mb-4" />
            <h4>Подател на сигнал</h4>
            <div class="col">
              <div class="row mb-3">
                <div>
                  <label class="col-form-label">Тел: <span class="font-danger">*</span></label>
                  <div class="phone-wrapper">
                    <ngx-intl-tel-input [cssClass]="'phone-input'"
                                        [enableAutoCountrySelect]="true"
                                        [enablePlaceholder]="true"
                                        [searchCountryFlag]="true"
                                        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]"
                                        [selectFirstCountry]="false"
                                        [selectedCountryISO]="CountryISO.Bulgaria"
                                        [maxLength]="15"
                                        [phoneValidation]="true"
                                        [separateDialCode]="true"
                                        [customPlaceholder]="'Въведете тел. номер'"
                                        formControlName="phoneNumber">
                    </ngx-intl-tel-input>
                  </div>
                </div>
              </div>
              <div class="row g_3 mb-3" style="display:none;">
                <div class="col-md-4 col-sm-12">
                  <label class="col-form-label">Име: <span class="font-danger">*</span></label>
                  <input class="form-control"
                         type="text"
                         formControlName="firstName"
                         placeholder="Въведете име" />
                </div>
                <div class="col-md-4 col-sm-12">
                  <label class="col-form-label">Презиме</label>
                  <input class="form-control"
                         type="text"
                         formControlName="middleName"
                         placeholder="Въведете презиме" />
                </div>
                <div class="col-md-4 col-sm-12">
                  <label class="col-form-label">Фамилия <span class="font-danger">*</span></label>
                  <input class="form-control"
                         type="text"
                         formControlName="lastName"
                         placeholder="Въведете фамилия" />
                </div>
                <div class="col-md-4 col-sm-12">
                  <label class="col-form-label">Емайл</label>
                  <input class="form-control"
                         type="text"
                         formControlName="email"
                         placeholder="Въведете Емайл" />
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-12 col-sm-12">

                  <label for="responseType">Вид Обратна Връзка</label>
                  <select class="form-select" formControlName="responseType">
                    <ng-container *ngFor="let r of responseTypes">
                      <option [ngValue]="r.key">
                        {{ getCyrilicRequestType(r.key) }}
                      </option>
                    </ng-container>
                  </select>

                </div>
              </div>

              <hr class="mt-4 mb-4" />
            </div>
          </section>

          <!-- Signal description form fields -->
          <h4>Описание на инцидента</h4>
          <div class="mb-3">
            <label class="col-form-label">Заглавие: </label>
            <input class="form-control"
                   type="text"
                   formControlName="title"
                   placeholder="Въведете Заглавие" />
          </div>

          <div class="mb-3">
            <label class="col-form-label">Тип на аварията: <span class="font-danger">*</span></label>
            <select formControlName="avariaType" class="form-select">
              <option [ngValue]="null" disabled>
                Изберете тип на аварията от падащия списък
              </option>
              <ng-container *ngFor="let item of avariaTypesList">
                <ng-container *ngIf="item.isActive">
                  <option [ngValue]="item.id">{{ item.title }}</option>
                </ng-container>
              </ng-container>
            </select>
          </div>
          <div class="mb-3">
            <label class="col-form-label">Описание на инцидента</label>
            <textarea rows="5"
                      cols="5"
                      placeholder="Въведете допълнително описание"
                      class="form-control"
                      formControlName="description"
                      spellcheck="false">

</textarea>
          </div>



          <button type="submit"
                  [name]="positiveSignalStatus.id"
                  class="btn btn-primary"
                  [disabled]="!form.valid">
            {{ positiveSignalStatus.title }}
          </button>
     
        </div>
      </div>

    </form>
  </div>

</ng-container>

